import ColorSchema from "../../kits/Color";
import { TrashIcon } from "../../kits/Icons";

import { swalFunc } from "../../../utils/helperFunction";

export default function FormulationListItem({ itemData, deactiveFormulation }) {
  return (
    <li className="formulation-list-item mb-1">
      <div className=" d-flex ">
        <div
          className="ms-auto bg-danger p-1 rounded-pill"
          style={{ cursor: "pointer" }}
          onClick={() =>
            swalFunc(
              `آیا از حذف این فرمول مطمئن هستید؟`,
              () => deactiveFormulation(itemData.id, -1),
              "warning"
            )
          }
        >
          <TrashIcon
            color={ColorSchema.white_custom}
            style={{ width: 20, height: 20 }}
          />
        </div>
      </div>
      <div className="d-flex">
        <div className=" col-5" style={{ lineHeight: "1.7" }}>
          <div className="d-flex flex-wrap">
            <h6 className="title">ماده اولیه :</h6>
            <p className="value ms-2">
              {itemData?.made_from_product?.title ?? "---"}
            </p>
          </div>
          <div className="d-flex ">
            <h6 className="title">الویت :</h6>
            <p className="value ms-2">{itemData?.priority}</p>
          </div>
          <div className="d-flex ">
            <h6 className="title">کدگروه :</h6>
            <p className="value ms-2">{itemData?.group_code}</p>
          </div>
          {/* <div className="d-flex flex-wrap">
            <h6 className="title">مقدار بازای هر واحد :</h6>
            <p className="value ms-2" dir="ltr">
              {itemData?.count_val}
            </p>
          </div> */}
        </div>

        <div className="col-7">
          <h6 className="title">فرمولها :</h6>
          <ol
            className="px-4 mt-2"
            style={{ listStyleType: "alpha", lineHeight: 1.5 }}
          >
            {itemData?.formuls?.map((v) => (
              <li>
                {v?.propertyName}&nbsp;{v?.formul}
              </li>
            ))}
          </ol>
        </div>
      </div>
    </li>
  );
}
